import { SET_BADGES_METADATA } from 'constants/reduxActions';
import { BadgesState } from 'types/badges';
import { BadgesAction } from 'actions/badges';

const initialState = {
  metadata: []
};

export default function badges(state: Readonly<BadgesState> = initialState, action: BadgesAction): BadgesState {
  switch (action.type) {
    case SET_BADGES_METADATA:
      const { metadata } = action;
      return {
        ...state,
        metadata
      };
    default:
      return state;
  }
}
